import { useEffect, useMemo, useState } from 'react';
import styles from './sidebar.module.scss';
import { SidebarSellersProps } from '../../../../interfaces/components';
import { useProfileRole, useToast } from '../../../../helpers/hooks';
import { capitalize, formatRut, validateRut } from '../../../../helpers/app';
import CheckboxShared from '../../../../components/Checkbox/Checkbox';
import ButtonShared from '../../../../components/Button/Button';
import SidebarShared from '../../../../components/Sidebar/Sidebar';
import SelectShared from '../../../../components/Select/Select';
import TextFieldShared from '../../../../components/TextField/TextField';
import { ROLES, STATUS } from '../../../../constants/profile';
import PhoneInput from '../../../../components/PhoneInput/PhoneInput';

const Sidebar = ({
    user,
    state,
    setState,
    sellerSelected,
    getSellers,
    addSeller,
    cleanAddSeller,
    sellers,
    editSeller,
    cleanEditSeller,
    branches
}: SidebarSellersProps) => {
    const toast = useToast();
    const profileRole = useProfileRole();
    const [name, setName] = useState<any>({value: "", error: ""});
    const [lastName, setLastName] = useState<any>({value: "", error: ""});
    const [password, setPassword] = useState<any>({
        value: "", 
        error: "", 
        validation: {
            specialCaracter: false,
            mayus: false,
            correctLength: false,
            number: false
        }
    });
    const [rut, setRut] = useState<any>({value: "", error: ""});
    const [phoneValue, setPhoneValue] = useState<any>({code: "", number: "", error: ""});
    const [branchSelected, setBranchSelected] = useState<any>({value: "", error: ""});
    const [email, setEmail] = useState<any>({value: "", error: ""});
    const [roleSelected, setRoleSelected] = useState<any>({value: "", error: ""});
    const [statusSelected, setStatusSelected] = useState<any>({value: "", error: ""});

    const handleChangePhone = (value: any, type: string) => {
        if(type === "code"){
            setPhoneValue({...phoneValue, code: value});
        }else{
            setPhoneValue({...phoneValue, number: value});
        }
    }

    const handleSendInvitation = () => {
        if(user?._id === sellerSelected?._id){
            return toast("No puedes modificar tu cuenta");
        }

        if(!name?.value) {return setName({...name, error: "Debes ingresar un nombre"})} else setName({...name, error: ""});
        if(!lastName?.value) {return setLastName({...lastName, error: "Debes ingresar un apellido"})} else setLastName({...lastName, error: ""});
        if(!email?.value) {return setEmail({...email, error: "Debes ingresar un email"})} else setEmail({...email, error: ""});
        if(state.type === "add" && !password?.value) {return setPassword({...password, error: "Debes ingresar una contraseña"})} else setPassword({...password, error: ""});
        
        if(user?.profile?.code === "admin-dealership"){
            if(!branchSelected?.value) {return setBranchSelected({...branchSelected, error: "Debes seleccionar una sucursal"})} else setBranchSelected({...branchSelected, error: ""});
        }
        
        if(state.type === "add"){
            if(!rut?.value) {return setRut({...rut, error: "Debes ingresar un RUT"})} else setRut({...rut, error: ""});
            if(!phoneValue?.code) {return setPhoneValue({...phoneValue, error: "Debes ingresar un pais"})} else setPhoneValue({...phoneValue, error: ""});
            if(!phoneValue?.number) {return setPhoneValue({...phoneValue, error: "Debes ingresar un telefono"})} else setPhoneValue({...phoneValue, error: ""});

            if(!validateRut(rut?.value)){
                return setRut({...rut, error: "RUT incorrecto"});
            }

            const phone = {
                code: phoneValue?.code,
                number: phoneValue?.number
            }

            let profileRole = null;
            if(user?.profile?.code === "admin-dealership"){
                profileRole = rolesNormalized.find((item: any) => item?.value === roleSelected?.value);
            }else{
                profileRole = rolesNormalized.find((item: any) => item?.value === "seller");
            }

            addSeller(
                {
                    "name": name?.value,
                    "last_name": lastName?.value,
                    "username": name?.value + capitalize(lastName?.value),
                    "password": password?.value,
                    "email": email?.value,
                    "legal_id": formatRut(rut?.value),
                    "phone": phone,
                    "country": "Argentina",
                    "profile": profileRole?.id
                },
                (user?.profile?.code === "admin-dealership") ? branchSelected?.value : user?.branch
            );
        }
        if(state.type === "edit"){
            const phone = {
                code: phoneValue?.code,
                number: phoneValue?.number,
            }

            const role = rolesNormalized.find((item: any) => item?.value === roleSelected?.value);


            editSeller(
                sellerSelected?._id, 
                {
                    "name": name?.value,
                    "last_name": lastName?.value,
                    "phone": phone,
                    "branch": user?.profile?.code === "admin-dealership" ? branchSelected?.value : user?.branch,
                    "status": sellerSelected?.status !== "pending" ? statusSelected?.value : sellerSelected?.status,
                    "profile": role?.id
                }
            );
        }
    }

    const handleChangeRut = (value: any) => {
        const formatValue = formatRut(value);
        if(!validateRut(formatValue)){
            return setRut({value: formatValue, error: "Ingresa un RUT válido"});
        }
        setRut({value: formatValue, error: ""});
    }

    const branchesNormalized: any = useMemo(() => {
        return branches?.data && branches?.data.map((branch: any) => (
            {
                id: branch?._id,
                name: branch?.name
            }
        ))
    }, [branches?.data]);

    const rolesNormalized: any = useMemo(() => {
        return ROLES && ROLES.map((role: any) => (
            {
                id: role?.code,
                value: role?.value,
                name: capitalize(role?.name)
            }
        ))
    }, [ROLES]);

    const statusNormalized: any = useMemo(() => {
        return STATUS && STATUS.map((state: any) => (
            {
                id: state?.code,
                name: capitalize(state?.name)
            }
        ))
    }, [STATUS]);

    useEffect(() => {
        if(sellerSelected?._id){
            setName({value: sellerSelected?.name, error: ""});
            setLastName({value: sellerSelected?.last_name, error: ""});
            setRut({value: formatRut(sellerSelected?.legal_id), error: ""});
            setPhoneValue({code: sellerSelected?.phone?.code, number: sellerSelected?.phone?.number, error: ""});
            setEmail({value: sellerSelected?.email, error: ""});
            setRoleSelected({value: sellerSelected?.profile?.name, error: ""});
            setBranchSelected({value: sellerSelected?.branch?._id, error: ""});
            setStatusSelected({value: sellerSelected?.status, error: ""});
        }else{
            setName({value: "", error: ""});
            setLastName({value: "", error: ""});
            setRut({value: "", error: ""});
            setPhoneValue({code: "+56", number: "", error: ""});
            setEmail({value: "", error: ""});
            setPassword({value: "", error: ""});
            setRoleSelected({value: "", error: ""});
            setBranchSelected({value: "", error: ""});
            setStatusSelected({value: "", error: ""});
        }
    }, [sellerSelected]);

    useEffect(() => {
        if(sellers?.add?.fetching === "failure"){
            cleanAddSeller();
            if(sellers?.add?.error === "LEGAL_ID_ALREADY_EXISTS"){
                setRut({...rut, error: "El RUT ya existe"})
                return toast("El RUT ya existe");
            }
            if(sellers?.add?.error === "EMAIL_ALREADY_EXISTS"){
                return toast("El email ya existe");
            }
            if(sellers?.add?.error === "EMAIL_INVALID_EMAIL"){
                setEmail({...email, error: "Ingresa un email valido"});
                return toast("Escribe un email valido");
            }
            toast("Ha ocurrido un error al añadir un nuevo vendedor");
        }
        if(sellers?.add?.fetching === "success"){
            toast("Vendedor añadido correctamente");
            setState({...state, open: false});
   
            if(user?.profile?.code !== "admin-brand") {
                if(user?.profile?.code === "admin-branch"){
                    getSellers(user?.branch, "branch", "sellers");
                }else{
                    getSellers(user?.dealership, "dealership", "sellers");
                }
            }
            cleanAddSeller();
        }
    }, [sellers?.add?.fetching]);

    useEffect(() => {
        if(sellers?.edit?.fetching === "failure"){
            toast("Ha ocurrido un error al editar el vendedor");
            cleanEditSeller();
        }
        if(sellers?.edit?.fetching === "success"){
            toast("Vendedor editado correctamente");
            setState({...state, open: false});
            // Skip API calls for admin-brand users
            if(user?.profile?.code !== "admin-brand") {
                if(user?.profile?.code === "admin-branch"){
                    getSellers(user?.branch, "branch", "sellers");
                }else{
                    getSellers(user?.dealership, "dealership", "sellers");
                }
            }
            cleanEditSeller();
        }
    }, [sellers?.edit?.fetching]);

    useEffect(() => {
        setState(state);
    }, [state]);

    return (
        <SidebarShared 
            variant="close" 
            open={state.open} 
            title={`${state.type === "add" ? "Nuevo" : state.type === "edit" ? "Editar": "Eliminar"} vendedor`} 
            onBack={() => setState({...state, open: false})} 
            id="sellersSidebarContent"
        >
            <div className={styles.sidebarContent}>
                <div className={styles.inputs}>
                    <TextFieldShared
                        label="Nombre"
                        name="name"
                        value={name?.value}
                        onChange={(value: any) => setName({...name, value: value})}
                        error={name?.error}
                        className={`${styles.input} ${styles.name} ${styles.half}`}
                    />
                    <TextFieldShared
                        label="Apellido"
                        name="lastName"
                        value={lastName?.value}
                        onChange={(value: any) => setLastName({...lastName, value: value})}
                        error={lastName?.error}
                        className={`${styles.input} ${styles.lastName} ${styles.half}`}
                    />
                    <TextFieldShared
                        label="RUT"
                        name="rutInput"
                        value={rut?.value}
                        className={`${styles.input} ${styles.full}`}
                        onChange={handleChangeRut}
                        error={rut?.error}
                        disabled={state.type !== "add"}
                    />
                    <PhoneInput
                        label="Telefono"
                        numberValue={phoneValue.number}
                        codeValue={phoneValue.code}
                        onChange={handleChangePhone}
                        error={phoneValue?.error}
                        className={`${styles.input} ${styles.full}`}
                    />
                    <TextFieldShared
                        label="Email"
                        name="email"
                        value={email?.value}
                        onChange={(value: any) => setEmail({...email, value: value})}
                        error={email?.error}
                        className={`${styles.input} ${styles.full}`}
                        disabled={state.type !== "add"}
                        onEnter={handleSendInvitation}
                    />
                    {
                        state.type === "add" &&
                        <>
                            <TextFieldShared
                                type="password"
                                label="Contraseña"
                                name="password"
                                value={password?.value}
                                onChange={(value: any) => setPassword({...password, value: value?.value, validation: value?.passValidate})}
                                error={password?.error}
                                className={`${styles.input} ${styles.full}`}
                            />
                        </>
                    }
                    {
                        profileRole(user?.profile?.code) === "admin" && state.type === "edit" && sellerSelected && sellerSelected?.status !== "pending" &&
                        <SelectShared
                            label="Estado"
                            name="status"
                            value={statusSelected?.value}
                            onChange={(value: any) => setStatusSelected({...statusSelected, value: value})}
                            className={`${styles.input} ${styles.full}`}
                            options={statusNormalized}
                        />
                    }
                    {
                        user?.profile?.code === "admin-dealership" &&
                        <>
                            <SelectShared
                                label="Rol"
                                name="role"
                                value={roleSelected?.value}
                                onChange={(value: any) => setRoleSelected({...roleSelected, value: value})}
                                className={`${styles.input} ${styles.full}`}
                                options={rolesNormalized}
                                keyValue="value"
                            />
                            <SelectShared
                                label="Sucursal"
                                name="branch"
                                value={branchSelected?.value}
                                onChange={(value: any) => setBranchSelected({...branchSelected, value: value})}
                                className={`${styles.input} ${styles.full}`}
                                options={branchesNormalized}
                            />
                        </>
                    }
                </div>
                <ButtonShared
                    onPress={handleSendInvitation}
                    title={
                        state.type === "add" 
                        ? "Enviar invitación" 
                        : state.type === "edit" 
                            ? "Editar"
                            : "Eliminar"
                    }
                    className={styles.sendInvitation}
                    primary
                    loading={sellers?.add?.fetching === "loading" || sellers?.edit?.fetching === "loading"}
                />
            </div>
        </SidebarShared>
    )
};
export default Sidebar;